import React, { Component } from "react";
import "styles/base.scss";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ReactGA from "react-ga";

import Header from "components/Header";

import Homepage from "routes/Homepage";

import SignUp from "routes/SignUp";
import SignIn from "routes/SignIn";
import ForgotPassword from "routes/ForgotPassword";
import Onboarding from "routes/Onboarding";
import Profile from "routes/Profile";

import Settings from "routes/Settings";

import ProjectCreate from "routes/ProjectCreate";
import ProjectEdit from "routes/ProjectEdit";
import ProjectDetail from "routes/ProjectDetail";

import Updates from "routes/Updates";

import * as ROUTES from "constants/routes";

import { withAuthentication } from "components/Session";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authUser: null
    };
  }
  componentDidMount() {
    this.listener = this.props.firebase.auth.onAuthStateChanged(authUser => {
      authUser
        ? this.setState({ authUser })
        : this.setState({ authUser: null });
    });
    setTimeout(
      () =>
        ReactGA.initialize("UA-133421616-2", { standardImplementation: true }),
      50
    );
  }

  componentWillUnmount() {
    this.listener();
  }
  render() {
    // const { user } = this.state;
    return (
      <div className="App">
        <Router>
          <>
            <Header authUser={this.state.authUser} />
            <Switch>
              <Route
                path={ROUTES.CREATE_PROJECT}
                exact
                component={ProjectCreate}
              />
              <Route path={ROUTES.EDIT_PROJECT} exact component={ProjectEdit} />
              <Route path={ROUTES.ONBOARDING} exact component={Onboarding} />
              <Route
                path={ROUTES.PROJECT_DETAIL}
                exact
                component={ProjectDetail}
              />
              <Route path={ROUTES.PROFILE} exact component={Profile} />

              <Route path={ROUTES.SETTINGS} exact component={Settings} />

              <Route path={ROUTES.SIGN_UP} exact component={SignUp} />
              <Route path={ROUTES.SIGN_IN} exact component={SignIn} />
              <Route
                path={ROUTES.FORGOT_PASSWORD}
                exact
                component={ForgotPassword}
              />

              <Route path={ROUTES.UPDATES} exact component={Updates} />

              {/* <Route
                path="/creatives"
                exact
                render={() => <div>Creatives</div>}
              /> */}
              {/* <Route path="/blog" exact render={() => <div>Blog</div>} /> */}
              <Route path={ROUTES.HOMEPAGE} component={Homepage} />
            </Switch>
          </>
        </Router>
      </div>
    );
  }
}

export default withAuthentication(App);
